import { useEffect } from 'react';
import { useSearchParams } from 'react-router';
import logo from '../../assets/icons/alpha_taxis_logo.svg';
import Text from '../../common/Text/Text';
import useToken from '../../hooks/useToken/useToken';
import { isValidUuid } from '../../utils/uuid/uuid';
import './Login.scss';

const Login = () => {
  const { setToken } = useToken();
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.has('uuid')) {
      const uuid = searchParams.get('uuid');

      if (isValidUuid(uuid)) setToken(uuid);
      setSearchParams(prev => {
        prev.delete('uuid');
        return prev;
      });
    }
  }, [searchParams, setToken, setSearchParams]);

  return (
    <div className="login">
      <div className="content">
        <img src={logo} className="logo" />
        <Text type="body">This Alpha Kiosk link is not assigned to a specific location.</Text>
        <Text type="body">
          Please contact Alpha Support to request or update your Kiosk access.
        </Text>
      </div>
    </div>
  );
};

export default Login;
